module.exports = __webpack_public_path__ + "static/bridge-3dc275ca8c6306237a50e7938b4cc242.png";